import React from 'react';

const WLSFooter = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="wls-footer">
      <hr aria-hidden="true" className="wls-footer-divider" />
      <div className="wls-footer-container">
        <div className="wls-footer-links">
      
          <a 
            href="https://newsprivacy.co.uk/" 
            target="_blank"
            rel="noopener noreferrer"
            className="wls-footer-link"
            id="privacy-preferences"
          >
            Privacy Preferences
          </a>
      
          <a 
            href="https://broadcasting.news/terms-of-use" 
            target="_blank"
            rel="noopener noreferrer"
            className="wls-footer-link"
            id="terms-of-use"
          >
            Terms of Use
          </a>
      
        </div>
        <hr aria-hidden="true" className="wls-footer-divider" />
        <p className="wls-footer-legal-text">© {currentYear} News UK Broadcasting Ltd. Our Terms of Use and Privacy Policy are applicable to you. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default WLSFooter;
